export const PUBLIC_V1 = 'public/v1'